import { ROOMS_ALL_ACTIONS_TYPE } from "../actions-type";

const initialState = {
  calendarData: [],
  rooms: [],
  totalLength: 0,
  hasMore: true,
  loading: false,
};

export const roomsCalendarPaginationReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ROOMS_ALL_ACTIONS_TYPE.ROOM_CALENDAR_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case ROOMS_ALL_ACTIONS_TYPE.GET_ROOMS_CALENDAR_PAGINATION:
      return {
        ...state,
        calendarData: [...state.calendarData, ...action.payload.result],
        rooms: action.payload.rooms,
        hasMore: !(action.payload.result.length < 20),
      };
    case ROOMS_ALL_ACTIONS_TYPE.RESET_ROOMS_CALENDAR_PAGINATION:
      return {
        ...state,
        calendarData: [],
        rooms: [],
        hasMore: true,
      };
    default:
      return state;
  }
};
